module.exports = __webpack_public_path__ + "img/nodata_dark_v.d28992b8.png";